// extracted by mini-css-extract-plugin
export default {"logoBar":"appbarTitle_logoBar__pW92B","header":"appbarTitle_header__X8TPb"};